var React = require('react');

function TabletAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 0H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zM224 480a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm176-108a12 12 0 0 1-12 12H60a12 12 0 0 1-12-12V60a12 12 0 0 1 12-12h328a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M48 60a12 12 0 0 1 12-12h328a12 12 0 0 1 12 12v312a12 12 0 0 1-12 12H60a12 12 0 0 1-12-12z","className":"fa-primary","key":2})]);
}

TabletAlt.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = TabletAlt;

TabletAlt.default = TabletAlt;
